import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
  FAQcategory: {},
  FAQcategories: [],
  search: [],
  totalPages: 0,
  allCategories: [],
};

// getters
const getters = {
  FAQcategory: (state) => {
    return state.FAQcategory;
  },
  FAQcategories: (state) => {
    return state.FAQcategories;
  },
  totalPages: (state) => {
    return state.totalPages;
  },
  search: (state) => {
    return state.search;
  },

  allCategories: (state) => {
    return state.allCategories;
  }
};

// mutations
const mutations = {
  SET_CATEGORY(state, FAQcategory) {
    state.FAQcategory = FAQcategory;
  },

  SET_CATEGORIES(state, FAQcategories) {
    state.FAQcategories = FAQcategories;
  },

  SET_ALL_CATEGORIES(state, allCategories) {
    state.allCategories = allCategories;
  },


  SET_CATEGORIES_SEARCH(state, FAQcategories) {
    state.search = FAQcategories;
  },

  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  ADD_CATEGORY(state, FAQcategory) {
    state.FAQcategories.push(JSON.parse(JSON.stringify(FAQcategory)));
  },

  UPDATE_CATEGORY(state, FAQcategory) {
    let categoryIndex = state.FAQcategories.findIndex((item) => {
      return item.id == FAQcategory.id;
    });
    FAQcategory.total_posts = state.FAQcategories[categoryIndex].total_posts;
    Vue.set(state.FAQcategories, categoryIndex, JSON.parse(JSON.stringify(FAQcategory)));
  },

  DELETE_CATEGORY(state, FAQcategory) {   
    let index = state.FAQcategories.indexOf(FAQcategory);
    if (index > -1) {
      state.FAQcategories.splice(index, 1);
    }
  },
};

// actions
const actions = {

  getAllFAQCategories ({commit}, page) {
    axios.get('/admin/faqcategories?page=' + page).then((response) => {
      let res = response.data;
      commit('SET_CATEGORIES', res.data);

      let totalPages = Math.ceil(res.total / res.per_page);
      commit('SET_TOTAL_PAGES', totalPages);
    });
  },

  getAllCategories ({commit}, query) {
    axios.get(`/admin/faq-categories?query=${query ? query : ''}`).then((response) => {
      let res = response.data;
      commit('SET_ALL_CATEGORIES', res.categories);

    }).catch(() => {
      commit('SET_ALL_CATEGORIES', []);
    });
  },

  // =========================================================================

  searchCategories({ commit }, [query, current_cat]) {
    if(current_cat == undefined)
      current_cat = '';

    return axios.get('/faqcategories/search?q=' + query + '&current=' + current_cat + '&admin=1')
      .then((response) => {
        // commit('SET_CATEGORIES_SEARCH', response.data);
        commit('SET_CATEGORIES_SEARCH', response.faq);
      });
  },

  // =========================================================================

  searchChildCategories({ commit }, query) {
    return axios.get('/faqcategories/search-child-FAQcategories?q=' + query)
      .then((response) => {
        commit('SET_CATEGORIES_SEARCH', response.data.data);
        // commit('SET_CATEGORIES_SEARCH', response.data);
      });
  },

  // =========================================================================

  getCategory({commit}, slug) {
    axios.get('/admin/faqcategories/' + slug)
    .then((response) => {
      colsole.log(response);
      commit('SET_CATEGORY', response.data.category);
    });
  },

  // =========================================================================

  createCategory ({commit}, category) {
    let moderatorId = null;
    let parent_category_id = null;

    // if (category.moderator != null) {
    //   moderatorId = category.moderator.id;
    // }

    if (category.parent_category != null) {
      parent_category_id = category.parent_category.id;
    }

    return axios.post('/admin/faqcategories', {
      title: category.title,
      description: category.description,
      // moderator: moderatorId,
      parent_id: parent_category_id,
    })
    .then((response) => {
      commit('ADD_CATEGORY', response.data.category);
    });
  },

  // =========================================================================

  updateCategory ({commit}, category) {
    let moderatorId = null;
    let parent_category_id = null;
    
    // if (category.moderator != null) {
    //   moderatorId = category.moderator.id;
    // }
    
    if (category.parent_category != null) {
      parent_category_id = category.parent_category.id;
    }
    
    return axios.post('/admin/faqcategories/' + category.slug, {
      _method: 'PUT',
      title: category.title,
      description: category.description,
      // moderator: moderatorId,
      parent_id: parent_category_id
    })
    .then((response) => {
      commit('UPDATE_CATEGORY', response.data.category);
    });
  },

  // =========================================================================

  deleteCategory({commit}, category) {
    return axios.post('/admin/faqcategories/' + category.id, {
      '_method': 'DELETE'
    })
    .then((response) => {
      commit('DELETE_CATEGORY', category);
      return response;
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
